import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import type { ComponentPropsWithoutRef } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

export interface LandingPageHeroDescriptionProps
  extends ComponentPropsWithoutRef<'p'> {
  readonly content: MessageKey;
  readonly hasBackgroundImage: boolean;
}

const LandingPageHeroDescription = ({
  className,
  content,
  hasBackgroundImage,
}: LandingPageHeroDescriptionProps) => {
  return (
    <Typography
      className={cx(
        'relative text-center text-base md:text-body-lg lg:text-left',
        {
          'text-center lg:text-left': hasBackgroundImage,
        },
        className,
      )}
      color="inherit"
      data-cy="landing-page-hero-description"
    >
      <RichText messageKey={content} />
    </Typography>
  );
};

export default LandingPageHeroDescription;
